// appear.ts
import { gsap } from 'gsap/gsap-core'
import { shouldApplyEffect } from '../utils';

export const init = (): void => {
    const elements = '[data-appear]';

    document.querySelectorAll<HTMLElement>(elements).forEach((item: HTMLElement) => {
        if (!shouldApplyEffect(item)) {
            gsap.set(item, { opacity: 1, y: 0 });
            return;
        }

        gsap.to(item, {
            opacity: 1,
            y: 0,
            scrollTrigger: {
                trigger: item,
                start: "top 70%",
                end: "top 30%",
                scrub: true,
                // markers: true,
            },
        });
    });
};
